//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { isSafari } from '@utils/isSafari';
import { EnumerableStorage } from './EnumerableStorage';
import { HybridCognitoStorage } from './HybridCognitoStorage';
import { IEnumerableCognitoStorage } from './IEnumerableCognitoStorage';

// On Safari, use a hybrid storage solution leveraging cookieStorage to work around iframe issues
export const amplifyStorage: IEnumerableCognitoStorage = isSafari() ?
    HybridCognitoStorage.createDefault() :
    EnumerableStorage.createDefault();
const rootUrl = window.location.origin + '/';

export const amplifyConfig = {
  aws_project_region: 'us-east-1',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: CURALATE_ENV.COGNITO_USER_POOL_ID,
  aws_user_pools_web_client_id: CURALATE_ENV.COGNITO_APP_CLIENT_ID,

  Auth: {
        // Manually set the authentication to USER_PASSWORD_AUTH, so that legacy user migration can work.
        // It will not work with the default USER_SRP_AUTH
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    storage: amplifyStorage,

    oauth: {
      domain: CURALATE_ENV.COGNITO_HOSTED_UI_DOMAIN,
      scope: ['email', 'profile', 'openid'] ,
      redirectSignIn: rootUrl,
      redirectSignOut: rootUrl,
      responseType: 'code',
    },
  },

  Analytics: {
        // The analytics feature adds an onBeforeUnload handler to window which prevents IE11 from navigating
        // away from the login page; which hurts our login process.
        // See: https://github.com/aws-amplify/amplify-js/issues/2088
    autoSessionRecord: false,
  },
};
